import { render } from "./NotRelationButton.vue?vue&type=template&id=136c434f"
import script from "./NotRelationButton.vue?vue&type=script&lang=js"
export * from "./NotRelationButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__